import { MenuItem } from '../models/menu.model';

export class Menu {
  public static pages: MenuItem[] = [
    {
      group: '',
      separator: false,
      items: [
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_Inicio.png',
          label: 'Inicio',
          tourName: 'tour-menu-dashboard',
          route: '/dashboard'
        },
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_Cuentas.png',
          label: 'Cuenta',
          tourName: 'tour-menu-cuentas',
          route: '/cuentas/gestion-cuentas',
        },
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_Vehiculo.png',
          label: 'Vehículos',
          tourName: 'tour-menu-vehiculo',
          route: '/vehiculo',
          /* children: [
            { label: 'Vehiculos', route: '/vehiculo/gestion' },
            { label: 'Tags', route: '/tag' },
          ], */
        },
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_MediosPago.png',
          label: 'Formas de pago',
          tourName: 'tour-menu-formas-pago',
          route: '/formas-pago'
        },
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_FlechasMovimiento.png',
          label: 'Movimientos',
          tourName: 'tour-menu-movimientos',
          route: '/movimientos'
        },
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_Facturas.png',
          label: 'Facturación',
          route: '/facturacion',
          tourName: 'tour-menu-datos-facturacion',
          children: [
            { label: 'Datos de facturación', route: '/facturacion/datos-facturacion' },
            /* { label: 'Ver facturas', route: '/facturacion/listado-facturas' }, */
          ],
        },
        {
          icon: 'assets/icons/img/TOLIS_Icon_Display_PQR.png',
          label: 'PQR',
          tourName: 'tour-menu-pqr',
          route: '/pqr',
          children: [
            { label: 'Generar PQR', route: '/pqr/crear-pqr' },
            { label: 'Ver PQR', route: '/pqr/listado-pqr' },
          ],
        },
        /* {
          icon: 'assets/icons/heroicons/outline/lock-closed.svg',
          label: 'Auth',
          route: '/auth',
          children: [
            { label: 'Sign up', route: '/auth/sign-up' },
            { label: 'Sign in', route: '/auth/sign-in' },
            { label: 'Forgot Password', route: '/auth/forgot-password' },
            { label: 'New Password', route: '/auth/new-password' },
            { label: 'Two Steps', route: '/auth/two-steps' },
          ],
        }, */
      ],
    },
    /* {
      group: 'Collaboration',
      separator: true,
      items: [
        {
          icon: 'assets/icons/heroicons/outline/download.svg',
          label: 'Download',
          route: '/download',
        },
        {
          icon: 'assets/icons/heroicons/outline/gift.svg',
          label: 'Gift Card',
          route: '/gift',
        },
        {
          icon: 'assets/icons/heroicons/outline/users.svg',
          label: 'Users',
          route: '/users',
        },
      ],
    }, */
    /* {
      group: 'Config',
      separator: false,
      items: [
        {
          icon: 'assets/icons/heroicons/outline/cog.svg',
          label: 'Settings',
          route: '/settings',
        },
        {
          icon: 'assets/icons/heroicons/outline/bell.svg',
          label: 'Notifications',
          route: '/gift',
        },
        {
          icon: 'assets/icons/heroicons/outline/folder.svg',
          label: 'Folders',
          route: '/folders',
          children: [
            { label: 'Current Files', route: '/folders/current-files' },
            { label: 'Downloads', route: '/folders/download' },
            { label: 'Trash', route: '/folders/trash' },
          ],
        },
      ],
    }, */
  ];
}
